import Animate from './Animate';
import AnimateChild from './AnimateChild';
import CSSMotion from './CSSMotion';

export { AnimateChild, CSSMotion };

export default Animate;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-animate@3.0.0-rc.6@rc-animate/es/index.js
// module id = 1286
// module chunks = 0